import TagManager from 'react-gtm-module';

export const onSocialShareHandler = (social: string): void => {
  TagManager.dataLayer({
    dataLayer: {
      event: 'social_share_click',
      social_name: social,
    },
  });
};
